// action types
const CHANGE_UNIT_DROPDOWN_STATUS =
  'rp/toggleDropdown/CHANGE_UNIT_DROPDOWN_STATUS'

// reducer
export default (state = false, { payload, type }) => {
  switch (type) {
    case CHANGE_UNIT_DROPDOWN_STATUS:
      return payload
    default:
      return state
  }
}

// action creators
// payload = boolean
export const toggleDropdown = payload => ({
  type: CHANGE_UNIT_DROPDOWN_STATUS,
  payload,
})
